import { K as u } from "./export-cdcbfb2b.js";
var s = { exports: {} };
(function(t) {
  function i(o, p) {
    if (o == null)
      return {};
    var r = {};
    for (var e in o)
      if ({}.hasOwnProperty.call(o, e)) {
        if (p.indexOf(e) !== -1)
          continue;
        r[e] = o[e];
      }
    return r;
  }
  t.exports = i, t.exports.__esModule = !0, t.exports.default = t.exports;
})(s);
var a = s.exports;
const n = /* @__PURE__ */ u(a);
export {
  n as _
};
